import { ProgramLanguageInfo, ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'

export type UnionMap<T extends string, S> = {
  [key in T]: S
}

export const programLanguageCodeMap: UnionMap<ProgramLanguageType, ProgramLanguageInfo> = {
  C: {
    name: 'C',
    suffix: 'c',
    code: 'c'
  },
  'C++': {
    name: 'C++',
    suffix: 'cpp',
    code: 'cpp'
  },
  'C++11': {
    name: 'C++11',
    suffix: 'cpp',
    code: 'cpp'
  },
  'C++14': {
    name: 'C++14',
    suffix: 'cpp',
    code: 'cpp'
  },
  'C++17': {
    name: 'C++17',
    suffix: 'cpp',
    code: 'cpp'
  },
  'C++20': {
    name: 'C++20',
    suffix: 'cpp',
    code: 'cpp'
  },
  'C++23': {
    name: 'C++23',
    suffix: 'cpp',
    code: 'cpp'
  },
  JAVA: {
    name: 'JAVA',
    suffix: 'java',
    code: 'java'
  },
  D: {
    name: 'D',
    suffix: 'd',
    code: 'd'
  },
  'C#': {
    name: 'C#',
    suffix: 'cs',
    code: 'csharp'
  },
  Scala: {
    name: 'Scala',
    suffix: 'scala',
    code: 'scala'
  },
  Python: {
    name: 'Python',
    suffix: 'py',
    code: 'python'
  },
  Python3: {
    name: 'Python3',
    suffix: 'py',
    code: 'python'
  },
  PyPy3: {
    name: 'PyPy3',
    suffix: 'py',
    code: 'python'
  },
  Ruby: {
    name: 'Ruby',
    suffix: 'rb',
    code: 'ruby'
  },
  JavaScript: {
    name: 'JavaScript',
    suffix: 'js',
    code: 'javascript'
  },
  Rust: {
    name: 'Rust',
    suffix: 'rs',
    code: 'rust'
  },
  Go: {
    name: 'Go',
    suffix: 'go',
    code: 'go'
  },
  Kotlin: {
    name: 'Kotlin',
    suffix: 'kt',
    code: 'kotlin'
  },
  PHP: {
    name: 'PHP',
    suffix: 'php',
    code: 'php'
  },
  Haskell: {
    name: 'Haskell',
    suffix: 'hs',
    code: 'haskell'
  },
  OCaml: {
    name: 'OCaml',
    suffix: 'ml',
    code: 'ocaml'
  }
}
